import React from "react"
import capitalize from "../utils/capitalize"
import { IconColorsType } from "../Icon"
import cx from "classnames"

type Extends<T, U extends T> = U

type ContainedIconColorType =
  | Extends<
      IconColorsType,
      | "base"
      | "accent"
      | "disabled"
      | "error"
      | "info"
      | "success"
      | "connect"
      | "keyExchange"
      | "rideshare"
      | "accentAlt"
      | "disabledAlt"
      | "errorAlt"
      | "infoAlt"
      | "successAlt"
      | "connectAlt"
    >
  | "baseAlt"

export type ContainedIconPropsType = {
  icon: React.JSX.Element
  color?: ContainedIconColorType
  className?: string
}

export function ContainedIcon({
  icon,
  color = "base",
  className,
}: ContainedIconPropsType) {
  return (
    <div
      className={cx(
        className,
        `cobalt-contained-icon cobalt-contained-icon--color${capitalize(color)}`
      )}
    >
      {icon}
    </div>
  )
}
